import { Injectable, InjectionToken, Type } from '@angular/core'
import { Params } from '@angular/router'
import { BehaviorSubject, Observable, Subject } from 'rxjs'
import { LocaleRouterService } from './locale-router.service'

export const POPUP_STATE = new InjectionToken("POPUP_STATE");

export interface PopupContent {
  component: Type<unknown>,
  state: unknown
};

type NullableComponent = PopupContent | null;

export type Mood = 'happy' | 'sad';

@Injectable({
  providedIn: 'root'
})
export class PopupService {
  visible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)  // false
  title: string = ''
  translateParams: unknown;
  answer: Subject<boolean> = new Subject()
  force: boolean = false

  success: boolean = false
  done: boolean = false

  actionAccept: BehaviorSubject<string> = new BehaviorSubject<string>('more')
  actionDecline: BehaviorSubject<string> = new BehaviorSubject<string>('home')
  mood: BehaviorSubject<Mood> = new BehaviorSubject<Mood>('happy')

  private contentSubject: BehaviorSubject<NullableComponent> = new BehaviorSubject<NullableComponent>(null);

  public get content$(): Observable<NullableComponent> {
    return this.contentSubject.asObservable();
  }

  constructor(private readonly router: LocaleRouterService) { }

  setParameters(parameters: {
    mood?: Mood,
    accept?: string,
    decline?: string,
  }) {
    const { mood, accept, decline } = parameters;
    mood ? this.setMood(mood) : this.setMood();
    accept ? this.setAccept(accept) : this.setAccept();
    decline ? this.setDecline(decline) : this.setDecline();
  }

  setMood(name: Mood = 'happy') {
    this.mood.next(name)
  }

  setAccept(name: string = 'more') {
    this.actionAccept.next(name)
  }

  setDecline(name: string = 'home') {
    this.actionDecline.next(name)
  }

  close(answer: boolean) {
    this.answer.next(answer);
    this.answer.complete();
    this.visible$.next(false);
    this.contentSubject.next(null);
    this.reset();
  }

  reset() {
    this.title = '';
    this.translateParams = undefined;
    this.setMood();
    this.setAccept();
    this.setDecline();
  }

  show(title: string, translateParams?: unknown): Observable<boolean> {
    this.title = title;
    this.translateParams = translateParams;
    this.visible$.next(true);
    this.answer = new Subject<boolean>();
    return this.answer.asObservable();
  }

  public showContent<T>(component: Type<unknown>, state?: unknown): Observable<boolean> {
    this.contentSubject.next({ component, state });
    this.visible$.next(true);
    this.answer = new Subject<boolean>();
    return this.answer.asObservable();
  }

  back(force: boolean = false, queryParams?: Params): Promise<boolean> {
    this.force = force
    return this.router.games();
  }
}
